import { Checkbox, FormControlLabel } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

export interface ApplyToPriceCheckboxProps {
  disabled?: boolean;
}

export const ApplyToPriceCheckbox = ({
  disabled,
}: ApplyToPriceCheckboxProps): JSX.Element => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name="applyToPrice"
      render={({ field: { onChange, value } }): JSX.Element => (
        <FormControlLabel
          control={
            <Checkbox
              checked={value}
              onChange={(e): void => onChange(e.target.checked)}
              disabled={disabled}
            />
          }
          label="Apply to Price"
        />
      )}
    />
  );
};
